const commonEn = {
    common: require('../../lang/en/common/Common').default,
    dashboard: require('../../lang/en/common/Dashboard').default,
    grn: require('../../lang/en/common/Grn').default,
    userLogin: require('../../lang/en/common/UserLogin').default,
};

export default commonEn;